/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { components } from '@seaoil/component-lib';
import {
  Row, Col, Grid,
  Form, Button, Input, Modal,
  notification,
} from 'antd';
import { v4 as uuidv4 } from 'uuid';
import { LayoutWithNav } from '../../components/Layout';
import LabelToolTip from '../../components/Feedback/LabelToolTip';
import FileUploader from '../../components/Inputs/FileUploader';
import RespondComponent from './RespondComponent';

const { useBreakpoint } = Grid;
const { TextArea } = Input;
const { Auth } = components;

const defaultStyle = {
  submitButton: {
    paddingLeft: '30px',
    paddingRight: '30px',
  },
  row: {
    justify: 'start',
    gutter: {
      xs: 8, sm: 16, md: 24, lg: 32,
    },
    style: {
      paddingLeft: '10%',
      paddingRight: '10%',
    },
  },
  col: {
    xs: {
      span: 24,
    },
    sm: {
      span: 12,
      offset: 6,
    },
  },
};

const mobileStyle = {
  ...defaultStyle,
  row: {
    ...defaultStyle.row,
    style: {
      paddingLeft: '5%',
      paddingRight: '5%',
    },
  },
  submitFormItem: {
    textAlign: 'center',
  },
};

function ucWord(word) {
  return word[0].toUpperCase() + word.substring(1, word.length);
}

function RespondWithRemarks(props) {
  const { location: { search } } = props;
  const [form] = Form.useForm();
  const screen = useBreakpoint();
  const [style, setStyle] = useState(defaultStyle);
  const [state, setState] = useState({
    remarks: '',
    redirect: false,
    attachment: [],
    uploading: false,
  });

  const query = new URLSearchParams(search);
  const action = query.get('action') || '';
  const taskId = query.get('taskId') || '';
  const controlNo = query.get('controlNo') || '';
  const dataset = query.get('dataset') || '';
  const withAttachment = Boolean(query.get('withAttachment')) || false;
  const attachmentConfig = (() => {
    if (!withAttachment) {
      return [];
    }

    try {
      const config = decodeURIComponent(query.get('attachmentConfig'));
      const result = JSON.parse(config);

      if (!Array.isArray(result)) {
        throw new Error(`attachmentConfig: ${JSON.stringify(result)} is not an array.`);
      }

      return result;
    } catch (e) {
      return ['Additional attachment'];
    }
  })();

  useEffect(() => {
    if (screen.xs) {
      setStyle(mobileStyle);
      return;
    }
    setStyle(defaultStyle);
  }, [screen]);

  const validateAttachment = () => {
    try {
      if (!withAttachment) {
        return [{
          success: true,
        }];
      }

      return attachmentConfig
        .filter((config) => config.required)
        .map((config) => {
          const { attachment } = state;
          const countOfAttachment = attachment.filter((file) => file.attachment_description === config.attachment_description).length;

          return {
            ...config,
            countOfAttachment,
          };
        })
        .filter((config) => config.countOfAttachment <= 0)
        .map((config) => ({
          success: false,
          message: `${config.attachment_description} is a required field`,
        }));
    } catch (e) {
      return {
        success: false,
        message: e.message || e,
        data: e,
      };
    }
  };

  const onSubmitHandler = async () => {
    const results = validateAttachment();
    const errorResults = results.filter((result) => !result.success);

    if (errorResults.length) {
      errorResults.forEach(({ message }) => notification.error({ message }));
      return;
    }

    Modal.confirm({
      title: 'Are you sure you want to submit?',
      content: (
        <div>
          <p>
            <strong>Remarks:</strong>
            {' '}
            {state.remarks || 'N/A'}
          </p>
        </div>
      ),
      async onOk() {
        setState((currState) => ({ ...currState, redirect: true }));
      },
    });
  };

  const Respond = () => (
    <RespondComponent config={{
      taskId,
      action,
      remarks: state.remarks,
      attachment: state.attachment,
    }}
    />
  );

  const actionLabel = (() => {
    if (action.toLowerCase().indexOf('rej') > -1) {
      return 'Reject/Return';
    }
    return ucWord(action);
  })();
  const fieldLabel = `${actionLabel} remarks for Control Number: ${controlNo}`;

  const AttachmentComponent = () => {
    if (!withAttachment) {
      return <></>;
    }

    return attachmentConfig.map(({ attachment_description }) => (
      <Row {...style.row} key={uuidv4()}>
        <Col {...style.col}>
          <Form.Item label={attachment_description}>
            <FileUploader
              config={{ dataset, maxAttachment: 10 }}
              onUpload={(uploading) => {
                console.log('uploading', uploading);
                // setState((currState) => ({
                //   ...currState,
                //   uploading,
                // }));
              }}
              onRemove={(attachments) => {
                const elms = state.attachment.filter((el) => el.attachment_description !== attachment_description);

                setState((currState) => ({
                  ...currState,
                  attachment: [
                    ...elms,
                    ...attachments.map((file) => ({
                      ...file,
                      attachment_description,
                    })),
                  ],
                }));
              }}
              onFinishUpload={(attachments) => {
                const elms = state.attachment.filter((el) => el.attachment_description !== attachment_description);

                setState((currState) => ({
                  ...currState,
                  attachment: [
                    ...elms,
                    ...attachments.map((file) => ({
                      ...file,
                      attachment_description,
                    })),
                  ],
                }));
              }}
            />
          </Form.Item>
        </Col>
      </Row>
    ));
  };

  const MainComponent = () => (
    <Auth.PrivateComponent redirect="/login">
      <LayoutWithNav>
        <Form form={form} layout="vertical" size="large" onFinish={onSubmitHandler}>
          <Row {...style.row}>
            <Col {...style.col}>
              <Form.Item label={<LabelToolTip label={fieldLabel} tip="You can indicate in this field if you have any reasons in returning/rejecting a request or if you will be approving the request and you would like to provide additional details" />}>
                <TextArea
                  showCount
                  maxLength={1000}
                  cols={50}
                  rows={4}
                  placeholder="Type-in your remarks here..."
                  onChange={(event) => {
                    setState((currState) => ({
                      ...currState,
                      remarks: event.target.value,
                    }));
                  }}
                  value={state.remarks}
                  disabled={state.uploading}
                />
              </Form.Item>
            </Col>
          </Row>
          {AttachmentComponent()}
          <Row>
            <Col xs={{ span: 24 }} align="middle" md={{ span: 24 }}>
              <Form.Item style={style.submitFormItem}>
                <Button
                  style={style.submitButton}
                  block={screen.xs}
                  disabled={state.redirect || state.uploading}
                  type="primary"
                  htmlType="submit"
                >
                  Submit
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </LayoutWithNav>
    </Auth.PrivateComponent>
  );

  const render = () => {
    if (state.redirect) {
      return Respond();
    }
    return MainComponent();
  };

  return render();
}

export default RespondWithRemarks;
